import _definePage_default_0 from 'D:/laragon/www/kwc-beta/resources/js/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'D:/laragon/www/kwc-beta/resources/js/pages/[...error].vue?definePage&vue'
import _definePage_default_3 from 'D:/laragon/www/kwc-beta/resources/js/pages/accept-invitation.vue?definePage&vue'
import _definePage_default_4 from 'D:/laragon/www/kwc-beta/resources/js/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_5 from 'D:/laragon/www/kwc-beta/resources/js/pages/activity-logs.vue?definePage&vue'
import _definePage_default_6 from 'D:/laragon/www/kwc-beta/resources/js/pages/auth/password-reset/forgot-password.vue?definePage&vue'
import _definePage_default_7 from 'D:/laragon/www/kwc-beta/resources/js/pages/auth/password-reset/update-password.vue?definePage&vue'
import _definePage_default_8 from 'D:/laragon/www/kwc-beta/resources/js/pages/auth/password-reset/verify-otp.vue?definePage&vue'
import _definePage_default_9 from 'D:/laragon/www/kwc-beta/resources/js/pages/backup_contacts.vue?definePage&vue'
import _definePage_default_10 from 'D:/laragon/www/kwc-beta/resources/js/pages/branch-codes/index.vue?definePage&vue'
import _definePage_default_11 from 'D:/laragon/www/kwc-beta/resources/js/pages/branches/[id].vue?definePage&vue'
import _definePage_default_12 from 'D:/laragon/www/kwc-beta/resources/js/pages/branches/create.vue?definePage&vue'
import _definePage_default_13 from 'D:/laragon/www/kwc-beta/resources/js/pages/branches/list.vue?definePage&vue'
import _definePage_default_14 from 'D:/laragon/www/kwc-beta/resources/js/pages/branches/view/[id].vue?definePage&vue'
import _definePage_default_15 from 'D:/laragon/www/kwc-beta/resources/js/pages/certifications/index.vue?definePage&vue'
import _definePage_default_16 from 'D:/laragon/www/kwc-beta/resources/js/pages/contacts/[id].vue?definePage&vue'
import _definePage_default_17 from 'D:/laragon/www/kwc-beta/resources/js/pages/contacts/create.vue?definePage&vue'
import _definePage_default_18 from 'D:/laragon/www/kwc-beta/resources/js/pages/contacts/details-[id].vue?definePage&vue'
import _definePage_default_19 from 'D:/laragon/www/kwc-beta/resources/js/pages/contacts/list.vue?definePage&vue'
import _definePage_default_20 from 'D:/laragon/www/kwc-beta/resources/js/pages/dashboard.vue?definePage&vue'
import _definePage_default_21 from 'D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/assignment_rules.vue?definePage&vue'
import _definePage_default_22 from 'D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/form_category.vue?definePage&vue'
import _definePage_default_23 from 'D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/forms.vue?definePage&vue'
import _definePage_default_24 from 'D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/list.vue?definePage&vue'
import _definePage_default_25 from 'D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/ticket/[id].vue?definePage&vue'
import _definePage_default_26 from 'D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/tickets.vue?definePage&vue'
import _definePage_default_27 from 'D:/laragon/www/kwc-beta/resources/js/pages/households.vue?definePage&vue'
import _definePage_default_28 from 'D:/laragon/www/kwc-beta/resources/js/pages/insurance-license-types/index.vue?definePage&vue'
import _definePage_default_29 from 'D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/[id].vue?definePage&vue'
import _definePage_default_30 from 'D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/create.vue?definePage&vue'
import _definePage_default_31 from 'D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/list/index.vue?definePage&vue'
import _definePage_default_32 from 'D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/view/[id].vue?definePage&vue'
import _definePage_default_33 from 'D:/laragon/www/kwc-beta/resources/js/pages/license-types/index.vue?definePage&vue'
import _definePage_default_34 from 'D:/laragon/www/kwc-beta/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_35 from 'D:/laragon/www/kwc-beta/resources/js/pages/organizations/[id].vue?definePage&vue'
import _definePage_default_36 from 'D:/laragon/www/kwc-beta/resources/js/pages/organizations/create.vue?definePage&vue'
import _definePage_default_37 from 'D:/laragon/www/kwc-beta/resources/js/pages/organizations/list/index.vue?definePage&vue'
import _definePage_default_38 from 'D:/laragon/www/kwc-beta/resources/js/pages/organizations/view/[id].vue?definePage&vue'
import _definePage_default_39 from 'D:/laragon/www/kwc-beta/resources/js/pages/organizations-deprecated.vue?definePage&vue'
import _definePage_default_40 from 'D:/laragon/www/kwc-beta/resources/js/pages/rep-codes/index.vue?definePage&vue'
import _definePage_default_41 from 'D:/laragon/www/kwc-beta/resources/js/pages/representatives/list/index.vue?definePage&vue'
import _definePage_default_42 from 'D:/laragon/www/kwc-beta/resources/js/pages/roles-management/list/index.vue?definePage&vue'
import _definePage_default_43 from 'D:/laragon/www/kwc-beta/resources/js/pages/system-settings/[tab].vue?definePage&vue'
import _definePage_default_44 from 'D:/laragon/www/kwc-beta/resources/js/pages/teams/list/index.vue?definePage&vue'
import _definePage_default_45 from 'D:/laragon/www/kwc-beta/resources/js/pages/teams/view/[id].vue?definePage&vue'
import _definePage_default_46 from 'D:/laragon/www/kwc-beta/resources/js/pages/user-invites/list/index.vue?definePage&vue'
import _definePage_default_47 from 'D:/laragon/www/kwc-beta/resources/js/pages/user-management/[id].vue?definePage&vue'
import _definePage_default_48 from 'D:/laragon/www/kwc-beta/resources/js/pages/user-management/create.vue?definePage&vue'
import _definePage_default_49 from 'D:/laragon/www/kwc-beta/resources/js/pages/user-management/list/index.vue?definePage&vue'
import _definePage_default_50 from 'D:/laragon/www/kwc-beta/resources/js/pages/user-management/view/[id].vue?definePage&vue'
import _definePage_default_51 from 'D:/laragon/www/kwc-beta/resources/js/pages/workflows/[id].vue?definePage&vue'
import _definePage_default_52 from 'D:/laragon/www/kwc-beta/resources/js/pages/workflows/create.vue?definePage&vue'
import _definePage_default_53 from 'D:/laragon/www/kwc-beta/resources/js/pages/workflows/details-[id].vue?definePage&vue'
import _definePage_default_54 from 'D:/laragon/www/kwc-beta/resources/js/pages/workflows/list.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: 'root',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  _mergeRouteRecord(
  {
    path: '/accept-invitation',
    name: 'accept-invitation',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/accept-invitation.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/account-settings',
    /* internal name: 'account-settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'account-settings-tab',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/account-settings/[tab].vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/activity-logs',
    name: 'activity-logs',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/activity-logs.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/auth',
    /* internal name: 'auth' */
    /* no component */
    children: [
      {
        path: 'password-reset',
        /* internal name: 'auth-password-reset' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password',
            name: 'auth-password-reset-forgot-password',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/auth/password-reset/forgot-password.vue'),
            /* no children */
          },
  _definePage_default_6
  ),
  _mergeRouteRecord(
          {
            path: 'update-password',
            name: 'auth-password-reset-update-password',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/auth/password-reset/update-password.vue'),
            /* no children */
          },
  _definePage_default_7
  ),
  _mergeRouteRecord(
          {
            path: 'verify-otp',
            name: 'auth-password-reset-verify-otp',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/auth/password-reset/verify-otp.vue'),
            /* no children */
          },
  _definePage_default_8
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/backup_contacts',
    name: 'backup-contacts',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/backup_contacts.vue'),
    /* no children */
  },
  _definePage_default_9
  ),
  {
    path: '/branch-codes',
    /* internal name: 'branch-codes' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'branch-codes',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/branch-codes/index.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/branches',
    /* internal name: 'branches' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'branches-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/branches/[id].vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'branches-create',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/branches/create.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'branches-list',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/branches/list.vue'),
        /* no children */
      },
  _definePage_default_13
  ),
      {
        path: 'view',
        /* internal name: 'branches-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'branches-view-id',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/branches/view/[id].vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      }
    ],
  },
  {
    path: '/certifications',
    /* internal name: 'certifications' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'certifications',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/certifications/index.vue'),
        /* no children */
      },
  _definePage_default_15
  )
    ],
  },
  {
    path: '/contacts',
    /* internal name: 'contacts' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'contacts-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/contacts/[id].vue'),
        /* no children */
      },
  _definePage_default_16
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'contacts-create',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/contacts/create.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
  _mergeRouteRecord(
      {
        path: 'details-:id',
        name: 'contacts-details-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/contacts/details-[id].vue'),
        /* no children */
      },
  _definePage_default_18
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'contacts-list',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/contacts/list.vue'),
        /* no children */
      },
  _definePage_default_19
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/dashboard.vue'),
    /* no children */
  },
  _definePage_default_20
  ),
  {
    path: '/demo-account',
    /* internal name: 'demo-account' */
    /* no component */
    children: [
      {
        path: '',
        name: 'demo-account',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/demo-account/index.vue'),
        /* no children */
      },
      {
        path: ':masterAccountId',
        name: 'demo-account-master-account-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/demo-account/[masterAccountId].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/helpdesk',
    /* internal name: 'helpdesk' */
    /* no component */
    children: [
      {
        path: '',
        name: 'helpdesk',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/index.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'assignment_rules',
        name: 'helpdesk-assignment-rules',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/assignment_rules.vue'),
        /* no children */
      },
  _definePage_default_21
  ),
  _mergeRouteRecord(
      {
        path: 'form_category',
        name: 'helpdesk-form-category',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/form_category.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
  _mergeRouteRecord(
      {
        path: 'forms',
        name: 'helpdesk-forms',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/forms.vue'),
        /* no children */
      },
  _definePage_default_23
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'helpdesk-list',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/list.vue'),
        /* no children */
      },
  _definePage_default_24
  ),
      {
        path: 'ticket',
        /* internal name: 'helpdesk-ticket' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'helpdesk-ticket-id',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/ticket/[id].vue'),
            /* no children */
          },
  _definePage_default_25
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'tickets',
        name: 'helpdesk-tickets',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/helpdesk/tickets.vue'),
        /* no children */
      },
  _definePage_default_26
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/households',
    name: 'households',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/households.vue'),
    /* no children */
  },
  _definePage_default_27
  ),
  {
    path: '/insurance-license-types',
    /* internal name: 'insurance-license-types' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'insurance-license-types',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/insurance-license-types/index.vue'),
        /* no children */
      },
  _definePage_default_28
  )
    ],
  },
  {
    path: '/investment-companies',
    /* internal name: 'investment-companies' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'investment-companies-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/[id].vue'),
        /* no children */
      },
  _definePage_default_29
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'investment-companies-create',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/create.vue'),
        /* no children */
      },
  _definePage_default_30
  ),
      {
        path: 'list',
        /* internal name: 'investment-companies-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'investment-companies-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/list/index.vue'),
            /* no children */
          },
  _definePage_default_31
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'investment-companies-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'investment-companies-view-id',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/investment-companies/view/[id].vue'),
            /* no children */
          },
  _definePage_default_32
  )
        ],
      }
    ],
  },
  {
    path: '/license-types',
    /* internal name: 'license-types' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'license-types',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/license-types/index.vue'),
        /* no children */
      },
  _definePage_default_33
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_34
  ),
  {
    path: '/organizations',
    /* internal name: 'organizations' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'organizations-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/organizations/[id].vue'),
        /* no children */
      },
  _definePage_default_35
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'organizations-create',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/organizations/create.vue'),
        /* no children */
      },
  _definePage_default_36
  ),
      {
        path: 'list',
        /* internal name: 'organizations-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'organizations-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/organizations/list/index.vue'),
            /* no children */
          },
  _definePage_default_37
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'organizations-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'organizations-view-id',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/organizations/view/[id].vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/organizations-deprecated',
    name: 'organizations-deprecated',
    component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/organizations-deprecated.vue'),
    /* no children */
  },
  _definePage_default_39
  ),
  {
    path: '/rep-codes',
    /* internal name: 'rep-codes' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'rep-codes',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/rep-codes/index.vue'),
        /* no children */
      },
  _definePage_default_40
  )
    ],
  },
  {
    path: '/representatives',
    /* internal name: 'representatives' */
    /* no component */
    children: [
      {
        path: 'list',
        /* internal name: 'representatives-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'representatives-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/representatives/list/index.vue'),
            /* no children */
          },
  _definePage_default_41
  )
        ],
      }
    ],
  },
  {
    path: '/roles-management',
    /* internal name: 'roles-management' */
    /* no component */
    children: [
      {
        path: 'list',
        /* internal name: 'roles-management-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'roles-management-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/roles-management/list/index.vue'),
            /* no children */
          },
  _definePage_default_42
  )
        ],
      }
    ],
  },
  {
    path: '/system-settings',
    /* internal name: 'system-settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'system-settings-tab',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/system-settings/[tab].vue'),
        /* no children */
      },
  _definePage_default_43
  )
    ],
  },
  {
    path: '/teams',
    /* internal name: 'teams' */
    /* no component */
    children: [
      {
        path: 'list',
        /* internal name: 'teams-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'teams-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/teams/list/index.vue'),
            /* no children */
          },
  _definePage_default_44
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'teams-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'teams-view-id',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/teams/view/[id].vue'),
            /* no children */
          },
  _definePage_default_45
  )
        ],
      }
    ],
  },
  {
    path: '/user-invites',
    /* internal name: 'user-invites' */
    /* no component */
    children: [
      {
        path: 'list',
        /* internal name: 'user-invites-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'user-invites-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/user-invites/list/index.vue'),
            /* no children */
          },
  _definePage_default_46
  )
        ],
      }
    ],
  },
  {
    path: '/user-management',
    /* internal name: 'user-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'user-management-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/user-management/[id].vue'),
        /* no children */
      },
  _definePage_default_47
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'user-management-create',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/user-management/create.vue'),
        /* no children */
      },
  _definePage_default_48
  ),
      {
        path: 'list',
        /* internal name: 'user-management-list' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'user-management-list',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/user-management/list/index.vue'),
            /* no children */
          },
  _definePage_default_49
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'user-management-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'user-management-view-id',
            component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/user-management/view/[id].vue'),
            /* no children */
          },
  _definePage_default_50
  )
        ],
      }
    ],
  },
  {
    path: '/workflows',
    /* internal name: 'workflows' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'workflows-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/workflows/[id].vue'),
        /* no children */
      },
  _definePage_default_51
  ),
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'workflows-create',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/workflows/create.vue'),
        /* no children */
      },
  _definePage_default_52
  ),
  _mergeRouteRecord(
      {
        path: 'details-:id',
        name: 'workflows-details-id',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/workflows/details-[id].vue'),
        /* no children */
      },
  _definePage_default_53
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'workflows-list',
        component: () => import('D:/laragon/www/kwc-beta/resources/js/pages/workflows/list.vue'),
        /* no children */
      },
  _definePage_default_54
  )
    ],
  }
]
